class AddToCartBanner extends HTMLElement {
  constructor() {
    super();
    this.hideTimeout = null;
  }

  connectedCallback() {
    // Set initial state and class
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('role', 'alert');
    this.classList.add('add-to-cart-banner');
    
    // Add popover attribute to ensure it appears above dialog backdrops
    this.setAttribute('popover', 'manual');
    
    // Create content
    this.innerHTML = `
      <div class="add-to-cart-banner__container">
        <p class="add-to-cart-banner__message">
          <span class="add-to-cart-banner__product-name"></span> has been added to your cart.
        </p>
      </div>
    `;
  }

  show(productName) {
    // Clear any existing timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }

    // Update product name
    const productNameElement = this.querySelector('.add-to-cart-banner__product-name');
    if (productNameElement) {
      productNameElement.textContent = productName;
    }


    // Show banner using popover API
    this.showPopover();
    
    // Small delay to ensure Safari properly initializes the element before animating
    requestAnimationFrame(() => {
      this.classList.add('add-to-cart-banner--visible');
      this.setAttribute('aria-hidden', 'false');
    });

    // Hide after 2.5 seconds
    this.hideTimeout = setTimeout(() => {
      this.hide();
    }, 2500);
  }

  hide() {
    this.classList.remove('add-to-cart-banner--visible');
    this.setAttribute('aria-hidden', 'true');
    
    // Wait for the fade-out animation to complete before hiding the popover
    setTimeout(() => {
      this.hidePopover();
    }, 500); // Match the CSS transition duration
    
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
  }
}

// Define the custom element
if (!customElements.get('add-to-cart-banner')) {
  customElements.define('add-to-cart-banner', AddToCartBanner);
}